import { ReactNode, SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { fontWeight, spacing, fontSize } from 'presentations/views/styles';
import { black, gray01, gray05 } from 'presentations/views/styles/color';
import Menu from 'presentations/views/components/atoms/Menu';
import Icon from 'presentations/views/components/atoms/Icon';
import FormPaidIcon from 'presentations/views/components/molecules/FormPaidIcon';
import { PlanId } from 'domains/models/subscription/planId';

interface Props {
  onCloseMenu?: any;
  onClickMenu?: any;
  onSelectMenu?: any;
  anchor?: any;
  anchorOrigin?: any;
  transformOrigin?: any;
  options: MenuOptions[];
}

export interface MenuOptions {
  icon?: string | ReactNode;
  iconColor?: any;
  label: string | ReactNode;
  disabled?: boolean;
  divider?: boolean;
  planId?: PlanId | null;
  link?: string | null;
}

export default function Component(props: Props) {
  const onMenuClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (props.onClickMenu) {
      props.onClickMenu(e);
    }
  };
  return (
    <Menu
      onClose={props.onCloseMenu}
      onSelect={props.onSelectMenu}
      anchor={props.anchor}
      anchorOrigin={props.anchorOrigin}
      transformOrigin={props.transformOrigin}
      options={props.options.map((option) => (
        <>
          {option.divider && <Hr />}
          {!option.divider && (
            <MenuItemLink href={option.link || undefined} onClick={onMenuClick}>
              {option.planId && (
                <PaidIcon>
                  <FormPaidIcon plan={option.planId} />
                </PaidIcon>
              )}
              <MenuItem disabled={option.disabled}>
                {option.icon && typeof option.icon === 'string' ? (
                  <MenuIcon
                    name={String(option.icon)}
                    styledColor={option.iconColor}
                  />
                ) : (
                  option.icon
                )}
                <MenuItemName>{option.label}</MenuItemName>
              </MenuItem>
            </MenuItemLink>
          )}
        </>
      ))}
    />
  );
}

const MenuItemLink = styled.a`
  display: block;
  color: ${black};
  width: 100%;
`;
const MenuItem = styled.div<{
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  font-size: ${fontSize(13)};
  font-weight: ${fontWeight('bold')};
  opacity: ${(props) => css`
    ${props.disabled ? 0.5 : 1};
  `};
`;
const MenuIcon = styled(Icon)<{ styledColor?: (props: any) => string }>`
  font-size: ${fontSize(20)} !important;
  width: 18px !important;
  height: 18px !important;
  color: ${(props) => props.styledColor ?? gray01};
`;
const MenuItemName = styled.div`
  margin-left: ${spacing(12)};
  color: ${gray01};
`;
const Hr = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${gray05};
`;
const PaidIcon = styled.div`
  margin-left: 2px;
`;
